import type { Tier } from '@/state/GameState';

export type FloorId =
  | 'tak'
  | 'direksjon'
  | 'redaksjon'
  | 'design'
  | 'marked'
  | 'resepsjon'
  | 'bokhandel'
  | 'kjeller';

export type FloorStatus = 'aapen' | 'laast' | 'tom';

export type UnlockKontekst = {
  antallUtgivelser: number;
  spillerTier: Tier;
};

export interface FloorDef {
  id: FloorId;
  label: string;
  etasje: string;
  beskrivelse: string;
  status: FloorStatus;
  unlockCondition?: (ctx: UnlockKontekst) => boolean;
  unlockHint?: string;
}

const TIER_ORDEN: ReadonlyArray<Tier> = ['D', 'C', 'B', 'A', 'S'];

function harTier(spillerTier: Tier, krav: Tier): boolean {
  return TIER_ORDEN.indexOf(spillerTier) >= TIER_ORDEN.indexOf(krav);
}

export const FLOORS: FloorDef[] = [
  {
    id: 'tak',
    label: 'Takterrasse',
    etasje: 'Tak',
    beskrivelse: 'Premium-avtaler og retreater. Åpner ved Tier B.',
    status: 'laast',
    unlockCondition: (ctx) => harTier(ctx.spillerTier, 'B'),
    unlockHint: 'Krever Tier B',
  },
  {
    id: 'direksjon',
    label: 'Direksjon',
    etasje: '6',
    beskrivelse: 'Strategi, budsjett, portefølje. Helhetsbildet av forlaget.',
    status: 'aapen',
  },
  {
    id: 'redaksjon',
    label: 'Redaksjon',
    etasje: '5',
    beskrivelse: 'Manuskripthåndtering. Hjertet av forlaget.',
    status: 'aapen',
  },
  {
    id: 'design',
    label: 'Design',
    etasje: '4',
    beskrivelse: 'Cover-utvikling og typografi.',
    status: 'aapen',
  },
  {
    id: 'marked',
    label: 'Marked og PR',
    etasje: '3',
    beskrivelse: 'Kampanjer og sosiale medier. Åpner ved Tier C.',
    status: 'laast',
    unlockCondition: (ctx) => harTier(ctx.spillerTier, 'C'),
    unlockHint: 'Krever Tier C',
  },
  {
    id: 'resepsjon',
    label: 'Resepsjon',
    etasje: '2',
    beskrivelse: 'Forfatter-møter og agent-besøk.',
    status: 'aapen',
  },
  {
    id: 'bokhandel',
    label: 'Bokhandel og foaje',
    etasje: '1',
    beskrivelse: 'Salg og retail.',
    status: 'aapen',
  },
  {
    id: 'kjeller',
    label: 'Trykkeri',
    etasje: 'Kjeller',
    beskrivelse: 'Produksjon og opplag. Åpner ved Tier C.',
    status: 'laast',
    unlockCondition: (ctx) => harTier(ctx.spillerTier, 'C'),
    unlockHint: 'Krever Tier C',
  },
];

export function findFloor(id: FloorId): FloorDef | undefined {
  return FLOORS.find((f) => f.id === id);
}

export function effektivStatus(floor: FloorDef, ctx: UnlockKontekst): FloorStatus {
  if (floor.status === 'laast' && floor.unlockCondition?.(ctx)) {
    return 'aapen';
  }
  return floor.status;
}
